import { useState, useEffect } from 'react';

export type OS = 'windows' | 'macos' | 'linux' | 'ios' | 'android' | 'unknown';
export type DeviceType = 'mobile' | 'tablet' | 'desktop';

export interface DeviceInfo {
  os: OS;
  deviceType: DeviceType;
  isMobile: boolean;
  isDesktop: boolean;
  isTablet: boolean;
  browser: string;
  isCompatible: boolean;
}

function detectOS(userAgent: string): OS {
  const ua = userAgent.toLowerCase();

  if (/iphone|ipad|ipod/.test(ua)) return 'ios';
  if (/android/.test(ua)) return 'android';
  if (/win32|win64|windows nt/.test(ua)) return 'windows';
  if (/macintosh|mac os x/.test(ua)) return 'macos';
  if (/linux/.test(ua) && !/android/.test(ua)) return 'linux';
  
  return 'unknown';
}

function detectDeviceType(userAgent: string, os: OS): DeviceType {
  const ua = userAgent.toLowerCase();

  if (os === 'ios' || os === 'android') {
    if (/ipad|tablet/.test(ua) || (os === 'ios' && !/iphone/.test(ua))) {
      return 'tablet';
    }
    return 'mobile';
  }

  if (/tablet|ipad/.test(ua)) return 'tablet';
  
  return 'desktop';
}

function detectBrowser(userAgent: string): string {
  const ua = userAgent.toLowerCase();

  if (/edg/.test(ua)) return 'Edge';
  if (/opr|opera/.test(ua)) return 'Opera';
  if (/chrome/.test(ua) && !/edg/.test(ua)) return 'Chrome';
  if (/safari/.test(ua) && !/chrome/.test(ua)) return 'Safari';
  if (/firefox/.test(ua)) return 'Firefox';
  
  return 'Unknown';
}

export function useDeviceDetect(): DeviceInfo {
  const [deviceInfo, setDeviceInfo] = useState<DeviceInfo>({
    os: 'unknown',
    deviceType: 'desktop',
    isMobile: false,
    isDesktop: true,
    isTablet: false,
    browser: 'Unknown',
    isCompatible: true,
  });

  useEffect(() => {
    const userAgent = navigator.userAgent;
    const os = detectOS(userAgent);
    const deviceType = detectDeviceType(userAgent, os);
    const browser = detectBrowser(userAgent);
    
    const isMobile = deviceType === 'mobile';
    const isTablet = deviceType === 'tablet';
    const isDesktop = deviceType === 'desktop';
    
    // Noteon działa tylko na desktopie (Windows, macOS, Linux)
    const isCompatible = isDesktop && ['windows', 'macos', 'linux'].includes(os);

    setDeviceInfo({
      os,
      deviceType,
      isMobile,
      isDesktop,
      isTablet,
      browser,
      isCompatible,
    });
  }, []);

  return deviceInfo;
}
